import React from 'react';

export function Avatar({ className, children }) {
  return <div className={`inline-block ${className}`}>{children}</div>;
}

export function AvatarFallback({ className, children }) {
  return <div className={`flex items-center justify-center ${className}`}>{children}</div>;
}